import security from "@/main";
import { getApiBaseUrl } from "@/config";

const resolve = (url) => url.startsWith("http://") || url.startsWith("https://") ? url : getApiBaseUrl() + url;

const handleResponse = function (response, success, error) {
    if (!response.ok) {
        if (response.status === 401) {
            this.logout();
        } else {
            if (error) {
                response.json().then (msg => {
                    error(msg);
                })
            }
        }

        return Promise.reject();
    }

    return response.blob().then(blob => {
        const data = new Blob([blob], {type: response.headers.get("Content-Type")});
        success(URL.createObjectURL(data));
    })
}


const handleJsonResponse = function (response, success, error) {
    if (!response.ok) {
        if (response.status === 401) {
            this.logout();
        } else {
            if (error) {
                response.json().then (msg => {
                    error(msg);
                })
            }
        }

        return Promise.reject();
    }

    return response.json().then(data => {
        success(data);
    })
}

export default {
    /**
     * Uploads a file to a given url.
     *
     * @param url the target url
     * @param file the file for upload
     * @param success callback for success
     * @param error callback for errors
     */
    upload (url, file, success, error) {
        let formData = new FormData();
        formData.append("file", file);

        fetch(resolve(url), {
            method :'POST',
            headers: security.header(),
            body   : formData
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },

    uploadReturnsJson (url, file, success, error) {
        let formData = new FormData();
        formData.append("file", file);

        fetch(resolve(url), {
            method :'POST',
            headers: security.header(),
            body   : formData
        })
            .then(response => {
                return handleJsonResponse(response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },

    /**
     * Loads an image or pdf from a given url
     *
     * @param url the target url
     * @param success callback for success
     * @param error callback for errors
     */
    load (url, success, error) {
        fetch(resolve(url), {
            headers: security.header(),
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },

    loadPost (url, body, success, error) {
        fetch(resolve(url), {
            method :'POST',
            headers: security.jsonHeader(),
            body   : JSON.stringify(body)
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },

    loadPut (url, body, success, error) {
        fetch(resolve(url), {
            method :'PUT',
            headers: security.jsonHeader(),
            body   : JSON.stringify(body)
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },

    call (url, body, success, error) {
        fetch(resolve(url), {
            method :'PUT',
            headers: security.jsonHeader(),
            body   : body
        })
            .then(response => {
                return handleResponse (response, success, error);
            })
            .catch(e => {
                if (error) error (e);
            });
    },
}